<template>

  <div class="advertiser-container">
    <span>满意度分析</span>
    <el-divider content-position="left"></el-divider>

    <el-form inline :model="searchForm" label-width="140px" style="margin-top: 30px;">
      <el-form-item label="工单日期">
		<el-date-picker
			v-model="searchForm.dateArray"
			type="daterange"
			range-separator="至"
			value-format="yyyy-M-d"
			start-placeholder="年/月/日"
			end-placeholder="年/月/日">
		</el-date-picker>
	  </el-form-item>
	  <el-form-item label="工单类型">
		 <el-select clearable v-model="searchForm.typeIds" placeholder="请选择">
			<el-option v-for="item in typeList" :key="item.value" :label="item.label"
				:value="item.value"></el-option>
		 </el-select>
	  </el-form-item>
      <el-button @click="onSearch" type="primary">搜索</el-button>
    </el-form>

    <el-divider content-position="left"></el-divider>


      <el-row :gutter="20">
            <el-col :span="2">
                <span class="demonstration">总体回复率</span>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="10"  align="middle">
                <el-progress :text-inside="true" :stroke-width="26" :percentage="AnalisysSurveyRate[0].rate"
                 :status="AnalisysSurveyRate[0].status"></el-progress>
            </el-col>
        </el-row>
    <!-- <div class="block">
        
    </div> -->
    <!-- </el-card> -->
    
    <el-card class="box-card" style="margin-top:20px;">
      <template #header>
        <div class="card-header">
          <span>各题平均满意度</span>
          <!-- <el-button class="button" type="text">操作按钮</el-button> -->
        </div>
      </template>

      <div style="margin-top:20px;margin-left:50px;">
        
          <el-row>
              <el-col :span="4"></el-col>
              <el-col  :span="4" align="middle">
                <!-- :status="AnalisysSurveyEach[0].a1status" -->
                  <el-progress type="dashboard" :format="format" :percentage="AnalisysSurveyEach[0].a1" ></el-progress>
              </el-col>
              <el-col  :span="4" align="middle">
                <!-- :status="AnalisysSurveyEach[0].a2status" -->
                  <el-progress type="dashboard" :format="format" :percentage="AnalisysSurveyEach[0].a2" ></el-progress>
              </el-col>
              <el-col  :span="4" align="middle">
                <!-- :status="AnalisysSurveyEach[0].a3status" -->
                  <el-progress type="dashboard" :format="format" :percentage="AnalisysSurveyEach[0].a3" ></el-progress>
              </el-col>
              <el-col  :span="4" align="middle">
                 <!-- :status="AnalisysSurveyEach[0].a4status" -->
                  <el-progress type="dashboard" :format="format" :percentage="AnalisysSurveyEach[0].a4"></el-progress>
              </el-col>
              <el-col :span="4"></el-col>
          </el-row>
          <el-row style="margin-top:10px;">
              <el-col :span="4"></el-col>
              <el-col :span="4" align="middle">
                  <span>整体满意度</span>
              </el-col>
              <el-col  :span="4" align="middle">
                  <span>服务满意度</span>
              </el-col>
              <el-col  :span="4" align="middle">
                  <span>时效满意度</span>
              </el-col>
              <el-col  :span="4" align="middle">
                  <span>解决方案满意度</span>
              </el-col>
              <el-col :span="4"></el-col>
          </el-row>
      </div>
    </el-card>
    <!-- <div style="margin-top:50px;">
        <span>问卷明细</span>
      </div> -->
    <el-card class="box-card"  style="margin-top:20px;">
      <template #header>
        <div class="card-header">
          <span>问卷明细</span>
          <!-- <el-button class="button" type="text">操作按钮</el-button> -->
        </div>
      </template>

      <el-table 
        :data="AnalisysSurveyList" 
        border :header-cell-style="{background:'#eef1f6',color:'#606266'}" height="750"
        style="width: 80%;margin-top: 20px;" ref="Table" >
        <el-table-column prop="sheetCode" align="center" label="工单编号" ></el-table-column>
        <el-table-column prop="title" align="center" label="工单主题" ></el-table-column>
        <el-table-column prop="a1" align="center" label="整体满意度"></el-table-column>
        <el-table-column prop="a2" align="center" label="服务满意度" ></el-table-column>
        <el-table-column prop="a3" align="center" label="时效满意度" ></el-table-column>
        <el-table-column prop="a4" align="center" label="解决方案满意度" ></el-table-column>
        <el-table-column prop="a7" align="center" label="意见建议" ></el-table-column>
      
      </el-table>
    </el-card>
  </div>
</template>

<script>

import CommonTable from "@/components/CommonTable";
import {getLatestMonthDateArrayByDate} from "@/utils/time";
import { mapGetters } from "vuex";
import { getToken } from "@/utils/auth";
import {encrypt} from "@/utils/encrypt";

export default {
  name: "Advertiser",
  components: { CommonTable}, 
  computed: { ...mapGetters(["typeList","AnalisysSurveyRate","AnalisysSurveyEach","AnalisysSurveyList"]) },
  data() {
    return {
      editOrderDialogVisible: false,
      searchForm: {
        dateArray: getLatestMonthDateArrayByDate({date:new Date(),delayNum:1, formatValue: 'yyyy-MM-dd'}),
        typeIds:'',
      },
      currentItem: {},
      

    };
  },
 

  async created() {
      await this.$store.dispatch("workSheet/typeList", {userId:getToken()});
    this.onSearch();
  },

  methods: {    
      format(percentage){
          return `${percentage/20}分`;
      },

    async onItemEditClick(item) {
      var code =item.distributorCode;
      console.log('code',code);
	    this.$router.push({name: 'DistributorDetail', params: {distributorCode: code}});
	  },

  

    async onSearch() {
        const [sDate, eDate] = this.searchForm.dateArray;
     

      await this.$store.dispatch("workSheet/AnalisysSurveySet", {
        sDate:sDate,
        eDate:eDate,
        typeIds:this.searchForm.typeIds,
      }).then(res=>{
        //   this.$refs.Table.doLayout();
        //   this.totalCount=this.distributorList.length
        //   this.currentPage=1

        //   this.totalfCount=this.finalUserWithDistributeList.length
        //   this.currentfPage=1
        console.log('AnalisysSurveyRate',this.AnalisysSurveyRate)
        console.log('AnalisysSurveyEach',this.AnalisysSurveyEach)
      });


    },


  },
};
</script>

<style scoped>

</style>